import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const SentimentNeutralIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0  40 40" style={{ color, fontSize, ...style }} {...rest}>
      <circle cx="19.5809" cy="19.6883" r="18.5809" stroke="#FCAC00" strokeWidth="2" />
      <circle cx="13.9983" cy="15.2034" r="1.90063" fill="#FCAC00" />
      <circle cx="25.1643" cy="15.2034" r="1.90063" fill="#FCAC00" />
      <path
        d="M13.9971 26.0621L25.1641 26.0621"
        stroke="#FCAC00"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  )
}
export default SentimentNeutralIcon
